module.exports = __webpack_public_path__ + "img/astral-txt_4.94437ee5.svg";